import React from 'react';
import Hero from '../../components/Hero/Hero';
import HomeAbout from '../../components/About/About';
import HomeCountries from '../../components/Countries/Countries';
import HomeNews from '../../components/News/News';
import AppDownload from '../../components/AppDownload/AppDownload';

const Home = () => {
  return (
    <div>
      <Hero />
      <AppDownload />
      <HomeAbout />
      <HomeCountries />
      <HomeNews />
    </div>
  );
};

export default Home;
